
<v-row class="no-frame">
    <v-col class="no-frame col-3 pr-1">
        <c-flip-card
            :enabled = "liftmanager && liftmanager.length > 0"
            v-model  = "flipCusLim"
            class    = "w-100"
            color    = "white--text"
            :top     = "3"
        >
            <template v-slot:front >
                <c-site-contact-row-menu
                    title     = "Ansprechpartner"
                    :contacts = "contacts.customer"
                    class     = "mr-1 w-100"
                >
                    <template v-slot:right>
                        <div class="mr-7" v-if="liftmanager && liftmanager.length > 0">
                            Liftmanager
                        </div>
                    </template>
                </c-site-contact-row-menu>
            </template>
            <template v-slot:back>
                <c-site-contact-row-menu
                    v-if="liftmanagerContacts"
                    title     = "Liftmanager"
                    :contacts = "liftmanagerContacts"
                    class     = "mr-2 w-100"
                >
                    <template v-slot:right>
                        <div class="mr-7">
                            Ansprechpartner
                        </div>
                    </template>
                </c-site-contact-row-menu>
            </template>
        </c-flip-card>
    </v-col>
    <v-col class="no-frame col-3">
        <c-site-contact-row-menu
            title     = "Ansprechpartner vor Ort"
            :contacts = "contacts.onSite"
            class     = "mr-1"
        />
    </v-col>
    <v-col class="no-frame col-3">
        <c-site-contact-row-menu
            :title     = "'Wartungsnehmer' + ((contracts && contracts.mntContract && contracts.mntContract.company) ? ' - ' + contracts.mntContract.company.name : '')"
            :contacts = "contacts.maintenance"
            class     = "mr-1"
        >
            <template v-slot:right>
                <div class="mnt-contract" v-if="contracts && contracts.mntContract">
                    {{ contracts.mntContract.contracttype ? contracts.mntContract.contracttype.name : '' }}
                </div>
            </template>
        </c-site-contact-row-menu>
    </v-col>
    <v-col class="no-frame col-3">
        <c-flip-card
            v-model="flipZusEsc"
            class="w-100"
            color="white--text"
            :top="3"
        >
            <template v-slot:front >
                <c-site-contact-row-menu
                    :title     = "'Notrufnehmer' + ((contracts && contracts.escContract && contracts.escContract.company) ? ' - ' + contracts.escContract.company.name : '')"
                    :contacts = "contacts.emc"
                    class     = "mr-1"
                >
                    <template v-slot:right>
                        <div class="mr-7">
                            ZÜS
                        </div>
                    </template>
                </c-site-contact-row-menu>
            </template>
            <template v-slot:back>
                <c-site-contact-row-menu
                    :title     = "(contracts && contracts.zusContract && contracts.zusContract.company) ? ('ZÜS - ' + contracts.zusContract.company.name) : 'ZÜS'"
                    :contacts = "contacts.zus"
                    class     = "w-100"
               >
                    <template v-slot:right>
                        <div class="mr-7">
                            Notrufnehmer
                        </div>
                    </template>
                </c-site-contact-row-menu>
            </template>
        </c-flip-card>
    </v-col>
</v-row>
